import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import { Modal, Row, Space, Typography } from 'antd';

import useAssurmaxContext from '../../contexts/AssurmaxContext';
import { routes, subRoutes } from '../../utils/constants/routes';

const AwaitingInformationModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { EXEMPTION_AWAITING_INFORMATION } = useAssurmaxContext();

  const navigateToExemption = () => {
    navigate(
      `${routes.QUOTES}${subRoutes.QUOTES.QUOTES_IN_EXEMPTION}`,
      'AWAITING_INFORMATION'
    );
  };

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      centered
      title={
        <Typography.Title style={{ fontSize: 17 }}>
          <Trans>{t('home.awaiting_information_modal.title')}</Trans>
        </Typography.Title>
      }
      okText={t('home.awaiting_information_modal.continue')}
      onOk={navigateToExemption}
      cancelText={t('home.awaiting_information_modal.close')}
      styles={{ body: { textAlign: 'center' } }}
    >
      <Trans>
        <Space orientation="vertical" align="center" size="middle">
          <Row justify="center">
            <Typography.Text>
              {t('home.awaiting_information_modal.body', {
                count: EXEMPTION_AWAITING_INFORMATION,
                context: EXEMPTION_AWAITING_INFORMATION > 1 ? 'plural' : 'one'
              })}
            </Typography.Text>
          </Row>
        </Space>
      </Trans>
    </Modal>
  );
};

export default AwaitingInformationModal;
